import { render, staticRenderFns } from "./SearchTab.vue?vue&type=template&id=6c33bd6c&scoped=true"
import script from "./SearchTab.vue?vue&type=script&lang=js"
export * from "./SearchTab.vue?vue&type=script&lang=js"
import style0 from "./SearchTab.vue?vue&type=style&index=0&id=6c33bd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c33bd6c",
  null
  
)

export default component.exports